import type { HttpClient } from '~/api/client';
import { httpClient } from '~/api/client';

export interface CartDataSource {
  getCartCount(): Promise<number>;
}

export class CartDataSourceImpl implements CartDataSource {
  // eslint-disable-next-line no-useless-constructor
  constructor(private readonly client: HttpClient = httpClient) {}

  async getCartCount() {
    return this.client.request<number>({
      url: '/api/market-place/v1/shopping-cart-items/count',
      method: 'get',
    });
  }
}

export const cartDataSource = new CartDataSourceImpl();
